export default __webpack_public_path__ + "static/media/carousel-img1.1fa02fdc.png";